export const spr2Validation = {
  methods: {
    spr2_getValidationState ({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    }
  }
}

export const spr2Procedures = {
  methods: {
    spr2_lookupTypeId (typeId) {
      var descriptor = 'unknown'
      switch (typeId) {
        case '5d537d8a0537a484cda16b96':
          descriptor = 'YesOrNo'
          break
        case '5d539144c7541f800a262427':
          descriptor = 'TextInput'
          break
        case '5ddc90bb46d3a6fab5a2731d':
          descriptor = 'Acknowledgement'
          break
        case '5f1e1542699b5fbdf8176d3e':
          descriptor = 'Checklist'
          break
        case '64f08edb6403dc3b99d3bcec':
          descriptor = 'ImageUpload'
          break
      }
      return descriptor
    }
  },
  computed: {
    spr2_isAuthenticated: {
      get: function () {
        return this.$auth.isAuthenticated && this.$store.state.spr2Profile != null
      }
    },
    isAuthenticated: {
      get: function () {
        return this.$auth.isAuthenticated && this.$store.state.spr2Profile != null
      }
    },
    spr_environment: {
      get: function () {
        return process.env.NODE_ENV
      }
    },
    spr_isDevelopmentEnv: {
      get: function () {
        return process.env.NODE_ENV === 'development'
      }
    },
    spr_isDevelopmentOrTestEnv: {
      get: function () {
        return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
      }
    }
  }
}
